import { useState } from 'react';
import SizeChart from './SizeChart';
import { Button } from 'components/common/Button';
import { Trans } from '@lingui/macro';
import { typesConfig } from '../constants';
import { Dialog } from '@headlessui/react';

export const SizeChartDialog = ({ type }) => {
  const [isOpen, setIsOpen] = useState(false);

  const onDialogCloseHandler = () => {
    setIsOpen(false);
  };

  return (
    <div className="text-center leading-4">
      <button
        type="button"
        className="text-xs md:text-xl font-semibold hover:underline border-none"
        onClick={() => setIsOpen(true)}
      >
        {!!type ? (
          <Trans>Click here for {typesConfig[type]?.label} Size Chart</Trans>
        ) : (
          <Trans>Click here to see our Size Chart</Trans>
        )}
      </button>

      <Dialog
        as="div"
        className="fixed inset-0 overflow-y-auto flex justify-center z-10"
        id="size-chart-dialog"
        open={isOpen}
        onClose={onDialogCloseHandler}
      >
        <div className="absolute inset-0 bg-black/90" aria-hidden="true" />

        <Dialog.Panel className="w-auto mx-5 mt-[10vh] max-w-6xl py-2 px-4 bg-white h-fit z-10">
          <Dialog.Title className="m-2 flex justify-end" as="div">
            <Button
              type="button"
              variant="light"
              onClick={onDialogCloseHandler}
            >
              x
            </Button>
          </Dialog.Title>
          <SizeChart />
        </Dialog.Panel>
      </Dialog>
    </div>
  );
};
